import React, { PureComponent } from "react";

import Switch from "Common/Switch/Switch";
import Carousel from "./Carousel";
import Filter from "./Filter";
import Pages from "./Pages";

import styles from "./Bloc.local.scss";
import classnames from "classnames";
import _ from "i18n";

export default class BlocComponent extends PureComponent {
  state = {
    displayFrom: false,
    switchChecked: this.props.enabled,
    title: this.props.label || this.props.type,
    label: this.props.label,
    url: this.props.url
  };

  componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      this.setState({
        switchChecked: this.props.enabled,
        title: (this.props.label || this.props.type).toUpperCase(),
        label: this.props.label,
        url: this.props.url
      });
    }
  }

  HandleDisplayFrom = e => {
    const { displayFrom, switchChecked } = this.state;

    if (!switchChecked) {
      return null;
    }

    const body = $(e.target)
      .parents("." + styles.bloc)
      .find("." + styles.body);
    if (displayFrom) {
      body.slideUp(500);
    } else {
      body.slideDown(500);
    }
    this.setState({ displayFrom: !displayFrom });
  };

  changeLngForm = (lng, e) => {
    if (e.currentTarget.classList.contains(styles.activated)) {
      return false;
    }
    $(e.currentTarget)
      .parent("ul")
      .find("li")
      .removeClass(styles.activated);
    e.currentTarget.classList.add(styles.activated);

    $(e.currentTarget)
      .parents("." + styles.body)
      .find("." + styles.inputs)
      .removeClass(styles.activated);

    $(e.currentTarget)
      .parents("." + styles.body)
      .find(`.inputs${lng}`)
      .addClass(styles.activated);
  };

  changeStatus = e => {
    const { indexSetting, setBlocStatus, order } = this.props;

    setBlocStatus(indexSetting, order, !this.state.switchChecked);
    this.setState({ switchChecked: !this.state.switchChecked });
  };

  changeTitle = (lng, e) => {
    const { setBlocTitle, order, indexSetting } = this.props;
    this.setState({
      ...this.state,
      title: e.currentTarget.value
    });
    setBlocTitle(indexSetting, order, lng, e.currentTarget.value);
  };

  changeSubtitle = (lng, e) => {
    const { indexSetting, setBlocSubtitle, order } = this.props;

    setBlocSubtitle(indexSetting, order, lng, e.currentTarget.value);
  };

  changeLabel = e => {
    console.log(e.currentTarget.value);
    const { setBlocLabel, order, indexSetting } = this.props;
    this.setState({
      ...this.state,
      label: e.currentTarget.value
    });
    setBlocLabel(indexSetting, order, e.currentTarget.value);
  };

  changeUrl = e => {
    const { indexSetting, setBlocUrl, order } = this.props;

    setBlocUrl(indexSetting, order, e.currentTarget.value);
  };

  newBloc = e => {
    const { type, order, addNewBloc } = this.props;
    addNewBloc(order, type);
  };

  removeBloc = e => {
    const { deleteBloc, indexSetting, order } = this.props;
    if (window.confirm(_("Do you really want to delete this block"))) {
      deleteBloc(indexSetting, order);
    }
  };

  renderDrawerForm() {
    const { order, indexSetting } = this.props;
    const { label, url } = this.state;

    return (
      <div className={styles.body}>
        <div className={styles.subHeader}>
          <span />
          <button onClick={this.removeBloc.bind(this)}>
            <i className="icon icon-trash" />
          </button>
        </div>
        <div className={styles.form}>
          <div className={styles.infos}>
            <div className={classnames(styles.inputs, styles.activated)}>
              <div className={styles.input}>
                <label>{_("Title")}</label>
                <input
                  type="text"
                  name="label"
                  value={label || ""}
                  className={styles.filled}
                  onChange={this.changeLabel.bind(this)}
                />
              </div>
              <div className={styles.input}>
                <label>{_("Link")}</label>
                <input
                  type="text"
                  name="Link"
                  defaultValue={url || ""}
                  onChange={this.changeUrl.bind(this)}
                />
              </div>
              <div className={styles.or}>
                <span>{_("or")}</span>
              </div>
              <Pages order={order} indexSetting={indexSetting} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { displayFrom, switchChecked, label } = this.state;

    const {
      type,
      order,
      icon,
      disposition,
      titleFR,
      subtitleFR,
      titleEN,
      subtitleEN,
      titleNL,
      subtitleNL,
      conditions,
      lng
    } = this.props;

    let helpType = type.toLowerCase();

    if (helpType == "album") {
      helpType = "media";
    }

    return (
      <div className={styles.bloc}>
        <div className={styles.header}>
          <div className={styles.left}>
            <img
              alt={type}
              src={
                icon ? icon : `https://s3.tamtam.pro/v2/apps/${helpType}.png`
              }
            />
            <h3>{label.toUpperCase() || type}</h3>
          </div>
          <div className={styles.right}>
            <span className={styles.activate}>
              {switchChecked ? _("Activated") : _("Disabled")}
            </span>
            <Switch
              checked={switchChecked}
              onChange={this.changeStatus.bind(this)}
            />
            <span
              className={classnames(
                styles.display,
                displayFrom ? styles.up : ""
              )}
              onClick={this.HandleDisplayFrom.bind(this)}
            />
          </div>
        </div>
        {type === "OTHER" ? (
          this.renderDrawerForm()
        ) : (
          <div className={styles.body}>
            <div className={styles.subHeader}>
              <ul>
                <li
                  className={styles.activated}
                  onClick={this.changeLngForm.bind(this, "FR")}
                >
                  <img src="/img/flags/fr.svg" alt={_("Frensh")} />
                  {_("Frensh")}
                </li>
                <li onClick={this.changeLngForm.bind(this, "EN")}>
                  <img src="/img/flags/en.svg" alt={_("English")} />
                  {_("English")}
                </li>
                <li onClick={this.changeLngForm.bind(this, "NL")}>
                  <img src="/img/flags/nl.svg" alt={_("Dutch")} />
                  {_("Dutch")}
                </li>
              </ul>
              <button onClick={this.removeBloc.bind(this)}>
                <i className="icon icon-trash" />
              </button>
            </div>
            <div className={styles.form}>
              <div className={styles.infos}>
                <div
                  className={classnames(
                    styles.inputs,
                    styles.activated,
                    "inputsFR"
                  )}
                >
                  <div className={styles.input}>
                    <label>{_("Titre")}</label>
                    <input
                      type="text"
                      name="titleFR"
                      defaultValue={titleFR}
                      className={styles.filled}
                      onChange={this.changeTitle.bind(this, "FR")}
                    />
                  </div>
                  <div className={styles.input}>
                    <label>{_("Sous-titre")}</label>
                    <input
                      type="text"
                      name="subtitleFR"
                      defaultValue={subtitleFR}
                      onChange={this.changeSubtitle.bind(this, "FR")}
                    />
                  </div>
                </div>
                <div className={classnames(styles.inputs, "inputsEN")}>
                  <div className={styles.input}>
                    <label>{_("Title")}</label>
                    <input
                      type="text"
                      name="titleEN"
                      className={styles.filled}
                      defaultValue={titleEN}
                      onChange={this.changeTitle.bind(this, "EN")}
                    />
                  </div>
                  <div className={styles.input}>
                    <label>{_("Subtitle")}</label>
                    <input
                      type="text"
                      name="subtitleEN"
                      defaultValue={subtitleEN}
                      onChange={this.changeSubtitle.bind(this, "EN")}
                    />
                  </div>
                </div>
                <div className={classnames(styles.inputs, "inputsNL")}>
                  <div className={styles.input}>
                    <label>{_("Titel")}</label>
                    <input
                      type="text"
                      name="titleNL"
                      className={styles.filled}
                      defaultValue={titleNL}
                      onChange={this.changeTitle.bind(this, "NL")}
                    />
                  </div>
                  <div className={styles.input}>
                    <label>{_("Ondertitel")}</label>
                    <input
                      type="text"
                      name="subtitleNL"
                      defaultValue={subtitleNL}
                      onChange={this.changeSubtitle.bind(this, "NL")}
                    />
                  </div>
                </div>
                <Carousel type={type} disposition={disposition} order={order} />
              </div>
              <Filter type={type} order={order} conditions={conditions} />
            </div>
            <div className={styles.addBloc}>
              <button
                className={styles.plus}
                onClick={this.newBloc.bind(this)}
              />
              <span>{_("Add new bloc")}</span>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/ManageLayout/Bloc/BlocComponent.js